// Used in makequest-iframe.component.html

// Angular
import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";

// Services/Types/Helpers
import { AssignmentUpload } from "#models/assignmentUpload.interface";
import { AssignmentUploadService } from "@carnegie-learning/data-access-angular-passport";
import { PPAssignment as Assignment } from "cli-types";

@Component({
    selector: "assignment-uploads",
    templateUrl: "./assignment-uploads.component.html",
    styleUrls: ["./assignment-uploads.component.scss"],
    standalone: false
})
export class AssignmentUploadsComponent implements OnInit, OnChanges {
    displayedColumns = ["fileName", "copyUrl", "deleteIcon"];

    uploadData = new MatTableDataSource<AssignmentUpload>();

    @Input() assignment: Assignment;
    @Input() apiUrl: string;

    @Output() deleteSuccess = new EventEmitter<any>();

    constructor(
        public assignmentUploadService: AssignmentUploadService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.uploadData.data = this.assignment.uploads;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.assignment) {
            this.uploadData.data = this.assignment.uploads;
        }
    }

    hasData() {
        return this.assignment.uploads && this.assignment.uploads.length > 0;
    }

    copyToClipboard(val: string) {
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
    }

    deleteFile(file: AssignmentUpload) {
        // console.log("deleting file...");
        this.assignmentUploadService
            .deleteFile(file.assignmentUploadID, this.apiUrl)
            .subscribe((response) => {
                this.deleteSuccess.emit(file);
            });
    }
}
